<template class="userLayout">
  <div id="userLayout" :class="['user-layout-wrapper', device]">

    <div class="main login-title-div">
      <div class="dygdiv">{{VUE_APP_PLATFORM_NAME}}</div>
    </div>

    <div class="container">
      <div class="container-right">
      <div class="top">
    </div>


      <route-view></route-view>
    
      </div>
      <div class="footer waveAnimation">
         <div class="waveWrapperInner bgTop">
          <div class="wave waveTop" ></div>
        </div>
        <div class="waveWrapperInner bgMiddle">
          <div class="wave waveMiddle" ></div>
        </div>
        <div class="waveWrapperInner bgBottom">
          <!-- <div class="wave waveBottom" ></div> -->
        </div>
        <!-- <div class="copyright">
          Copyright &copy; 2021
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {}
    },
    created(){
      this.$nextTick(() => {
        document.body.classList.add('userLayout');
      })
    },
    mounted () {
      this.$nextTick(() => {
        document.body.classList.add('userLayout');
      })
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout');
    },
  }
</script>

<style lang="less" scoped>

  .wyqp{
    overflow: hidden !important;
  }
  body.default{
    #userLayout.user-layout-wrapper{
      background: #1389d8 url(~@/assets/login-bg.png) no-repeat;
    }
  }
  body.whon-gov{
    #userLayout.user-layout-wrapper{
       background: #b30009 url(~@/assets/login-bg.png) no-repeat;
     }
  }

  #userLayout.user-layout-wrapper {
    height: 100%;
    background-size: cover;
    background-position-x: left;
    background-position-y: bottom;

    &.mobile {
      .container {
        z-index: 100;
        .main {
          max-width: 368px;
          width: 98%;
        }
        .container-right{
          float: inherit;
          margin-right: auto;
          z-index: 100;
        }
      }
    }

    .container {
      z-index: 100;
      width: 100%;
      min-height: 100%;
      background-size: 100%;
      padding: 12.11% 0 0 0;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            width: 597px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 432px;
        margin: 0 auto;
        position: relative;
        //background: url(~@/assets/main-bg.png) no-repeat ;
        background-size: 100% 100%;
        background-color: #fff;
        border-radius: 20px;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
    }
    .container-right{
      float: right;
      margin-right: 215px;
      z-index: 100;
    }
    .left-img{
      height: 600px;
      width: 597px;
      margin-left: 232px;
      margin-top: 30px;
    }
    }

  }

  #userLayout{
    &.mobile {
      .wbdiv{
        text-align: center;
        position: relative;
        top: 5px;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
      
      .login-title-div{
        height: 30px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        letter-spacing: 6px;
        text-align: center;
        padding-top: 5px;
      }
      
    }

    &.desktop{
      .dygdiv{
        height: 112px;
        font-size: 65px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 112px;
        letter-spacing: 6px;
      }

      .login-title-div{
        position: absolute;
        padding-top: 20%;
        padding-left: 20px;
        padding-right: 670px;
        width: 100%;
        text-align: center;
      }
    }

  }

</style>